<script setup lang="ts">
type Props = {
  to: string;
  text: string;
  disableIcon?: boolean;
  class?: string;
  selected?: boolean;
};

const props = defineProps<Props>();
</script>

<template>
  <NuxtLink
    :class="[
      'inline-flex items-center justify-center gap-2 text-lg font-medium text-on-primary-heading relative group no-underline',
      props.class,
    ]"
    :to="props.to"
  >
    <Icon v-if="!props.disableIcon" name="material-symbols:arrow-right-alt" />
    <span>{{ props.text }}</span>
    <span
      class="absolute -bottom-1.5 left-0 h-[2px] bg-on-primary-heading transition-[width] duration-[600ms] ease"
      :style="{ width: props.selected ? '100%' : '0%' }"
    ></span>
  </NuxtLink>
</template>
